import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";
import logo from "../../../../src/assets/forbidden-lands/forbidden-lands-logo.webp";
import sectionDivider from "../../../../src/assets/forbidden-lands/session16_17/bitter-reach-page-banner-session-16_17.webp";
import "../../../index.css";
import { ContentContainer } from "../SessionSection";
import ModalComponent from "../modal/modal.component";
import ImageComponent from "../image/image.component";
import { useEffect } from "react";
import "./blade-runner-styles.scss";
import bladeRunnerLogo from "../../../../src/assets/blade-runner/logo-blade-runner.webp";

import synth from "../../../../src/assets/blade-runner/session04/synth-magazine.webp";

import baselineMachine from "../../../../src/assets/blade-runner/session04/baseline-test-machine.webp";
import marionCracks from "../../../../src/assets/blade-runner/session04/marion-cracks.webp";
import skinnerStyles from "../../../../src/assets/blade-runner/session04/skinner-tackles-styles.webp";
import pamphlet from "../../../../src/assets/blade-runner/session04/off-world-pamphlet.webp";
import aurelion from "../../../../src/assets/blade-runner/session04/the-aurelian.webp";

const pageHeader = {
  color: "white",
  backgroundColor: "black",
  opacity: "0.7",
  marginTop: "20px",
  padding: "15px",
};
const cardStyle = {
  textAlign: "left",
  fontFamily: "Special Elite",
  backgroundColor: "rgba(0, 0, 0, 0.7) ",
  color: "white",
  marginBottom: "15px",
};

const BRSession04 = () => {
  const [showModal, setShowModal] = React.useState("");
  const [modalData, setModalData] = React.useState({});
  const handleClick = (img, body, isLegend, caption) => {
    setModalData({
      body: body,
      image: img,
      isLegend: isLegend,
      caption: caption,
    });
    handleOpenModal();
  };
  const handleOpenModal = () => {
    setShowModal("show");
  };
  const handleCloseModal = () => {
    setShowModal("", "");
  };

  const section1Data = [
    {
      title: "Breakdown at the Esper Wall (Day 2, Shift 4)",
      text: (
        <div class="bladeRunnerFont bladeRunnerTitleText">
          <ImageComponent
            image={marionCracks}
            caption="Marion Cracks"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Resolve damage breaks Marion at the Esper Wall. Seeing Leah getting into Metrokab, he loses it and punches the wall monitor."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <ImageComponent
            image={baselineMachine}
            caption="Baseline Machine"
            cssClass="imageRight"
            handleClick={handleClick}
            modalBody="Baseline PTBT testing machine."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          The static hum of the Esper machine filled the room, casting ghostly
          light on Marion Carey’s face as he stared into the grainy footage.
          There she was—Leah, slipping into a Metrokab, alone, unkidnapped,
          unharmed. The truth hit him like a side tackle.
          <br />
          <br />
          He’d believed she’d been taken. He'd built every move around that. Now
          that belief cracked, and with it, so did something deep inside him.
          <br />
          <br />
          Visions stormed his mind: Leah in her apartment, laughing—free. He
          thought about how he had never truly laughed. Not like that. Not
          since… well, ever.
          <br />
          <br />
          With a roar, the former MVP shattered the screen with a single punch.
          Sparks burst, and white snow filled the Esper monitor. Then silence.
          Marion collapsed, body hulking, mind blank, catatonic.
          <br />
          <br />
          Sgt. Reardon entered moments later.{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “You alright, Detective Carey? What happened?”
          </font>{" "}
          No response.
          <br />
          <br />
          Hours later, Marion sat in the cold dark of the baseline chamber. The
          PTBT machine blinked red as the AI prompted him:
          <br />
          <br />
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “State your baseline.”
          </font>
          <br />
          <br />
          Marion’s voice cracked as he recited his fabricated glories:
          <br />
          <br />
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “High school coach was named Watson. I scored 213 touchdowns...”
          </font>
          <br />
          <br />
          Memory by memory, stat by stat, the baseline held. He passed. But he
          no longer knew if he still believed it.
          <br />
          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },
    {
      title: "Skinner's Night at The Overlook",
      text: (
        <div class="bladeRunnerFont bladeRunnerTitleText">
          <ImageComponent
            image={skinnerStyles}
            caption="Tackling Styles"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Skinner tackles Styles in a brutal confrontation at The Overlooks."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          As the rain-slick city rolled into the twilight of Shift 4, Detective
          Skinner found his way to The Overlook, a bar as gaudy as it was
          comforting, perched high above the trash-strewn alleys. He sought
          answers from Lloyd, the N-9 bartender, but what he found was something
          else.
          <br />
          <br />
          In the bar’s neo-art-deco restroom, mirrors etched in gold, Skinner
          stumbled into Styles, tall and pale, snorting cocaine with the same
          dead-eyed hunger Skinner remembered from his childhood. Styles
          panicked, made a break for it—but Skinner tackled him, slamming him
          down in a brutal tackle even Marion would’ve cheered.
          <br />
          <br />
          Seeing Styles triggered a flood of buried pain—his parents at a
          nightclub, high, strangers to their own son. The city whispered to him
          then, and this time, Skinner stayed grounded. The badge held him
          steady.
          <br />
          <br />
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “Why are you running, Styles?”
          </font>{" "}
          he asked, breath heavy.
          <br />
          <br />
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            {" "}
            “We all run, cop. Those of us without a badge? That’s all we do.”
          </font>
          <br />
          <br />
          What followed was a philosophical exchange about freedom, the
          underground, and the city. Styles called out Wallace Corp’s grip,
          name-dropped the Aurelian on Animoid Row, and tried to get under
          Skinner’s skin but admitting he worked with the Replicant Underground
          to try and get Replicants off-world or settled landside if needed.
          <br />
          <br />
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “You can’t help her,”
          </font>{" "}
          Styles sneered.{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “Your unit answers to Wallace.”
          </font>
          <br />
          <br />
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “We answer to the city,” Skinner shot back. “And the city is me.
            It’s Leah. It’s you, Styles.”
          </font>
          <br />
          <br />
          Styles asked for a lawyer. Skinner gave him a card instead.
          <br />
          <br />
          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },
    {
      title: "Animoid Row - The Aurelian (Day 3, Shift 1)",
      text: (
        <div class="bladeRunnerFont bladeRunnerTitleText">
          <h4>The Eye Opener</h4>
          The next morning, Skinner offered Marion for a liquid breakfast at The
          Overlook.{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “Let’s get an eye-opener.”
          </font>
          <br />
          <br />
          At The Overlook, Marion looked haunted.
          <br />
          <br />
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            {" "}
            “Leah wasn’t kidnapped, Skinner. I saw it. She left on her own.”
          </font>
          <br />
          <br />
          Skinner listened quietly as Marion described the footage. He didn’t
          judge. And then he asked,{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            "Was this your first baseline? And I hate to ask, but are you in on
            this Marion?"
          </font>
          <br />
          <br />
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            {" "}
            “First forced baseline,”
          </font>{" "}
          Marion muttered.{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “Didn’t know I was that fragile. But, I'm not in on this; I'm on the
            case with you.”
          </font>
          <br />
          <br />
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            {" "}
            “Maybe Leah went through something like this,”
          </font>{" "}
          Skinner offered.
          <br />
          <br />
          The two detectives agreed: it was time to see the Aurelian.
          <br />
          <br />
          <h4>The Aurelian</h4>
          <ImageComponent
            image={aurelion}
            caption="The Aurelian"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="The Aurelian is a key figure in the underground replicant underground. He creates neon animoid butterflys in his shop on Animoid Row."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          Fog clung to the synthetic beasts and bioluminescent stalls as Skinner
          whispered to the street,
          <br />
          <br />
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            {" "}
            “If I were a butterfly, where would I be?”
          </font>
          <br />
          <br />
          They found the Aurelian’s shop nestled among the neon chaos of Animoid
          row. The shop was filled with fluttering jars of engineered insects.
          And also: Styles, inside talking to the Aurelian. Marion sneaked into
          the shop and crouched behind crates, listening.
          <br />
          <br />
          Styles:{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “Where is she now?”
          </font>
          <br />
          <br />
          Aurelian:{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “Safehouse. Until the sign in the Kipple. Then she’s gone.”
          </font>
          <br />
          <br />
          Styles:{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “She seemed… angry.”
          </font>
          <br />
          <br />
          Aurelian:{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “Yeah she did. Like she’s not done yet.”
          </font>
          <br />
          <br />
          When Styles exited, Skinner confronted him again but let him walk.
          Skinner didn’t buy the act, but Styles on the loose might be more
          valuable than having the rep locked up.
          <br />
          <br />
          Inside, Marion strong-armed the old man. The Aurelian played blind and
          innocent.
          <br />
          <br />
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            {" "}
            “This how y’all do in LAPD, hassling a blind man?”
          </font>
          <br />
          <br />
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            {" "}
            “Not if you talk,”
          </font>{" "}
          Marion growled.{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            "If I don't like what I hear, I'm taking you down to the station."
          </font>
          <br />
          <br />
          Skinner stepped in, smoothing over the tension. Two strong
          MANIPULATION rolls cracked the butterfly-maker’s shell.
          <br />
          <br />
          The Aurelian's accent dropped as he explained:{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “She’s at the safehouse. I don’t know the pickup time. Just my piece
            of the puzzle.”
          </font>
          <br />
          <br />
          Message received. Marion rattled his handcuffs as a reminder: Don’t
          play with Blade Runners.
          <br />
          <br />
          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },
    {
      title: "Safehouse (Day 3, Shift 2))",
      text: (
        <div class="bladeRunnerFont bladeRunnerTitleText">
          <ImageComponent
            image={synth}
            caption="SYNTH Magazine"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="SYNCH magazine with an article about Lilith Tyrell and her controversial methods of using traumatic memories to tame replicant behavior."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <ImageComponent
            image={pamphlet}
            caption="Off-World"
            cssClass="imageRight"
            handleClick={handleClick}
            modalBody="An off-world pamphlet in the Safehouse gives a clue as to Leah's intentions."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          As they ascended the crumbling stairwell of an ancient 5-story brick
          building near Hawker’s Circle, Marion’s KIA buzzed. Quell from Wallace
          Corp.
          <br />
          <br />
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “Give me results by Shift 3. Or Holden hears everything about your
            failure to deliver.”
          </font>
          <br />
          <br />
          Call ended.
          <br />
          <br />
          They reached the safehouse—alone, isolated, with a door that could
          only bolt from the inside.
          <br />
          <br />
          Inside: decay. Makeshift comforts. Dust on a cracked piano. Marion ran
          a finger over the piano keys again. No sound.
          <br />
          <br />
          And then: two clues.
          <br />
          <br />
          A flyer for Arcadia, promising freedom off-world via Shimago-Dominguez
          Corp.
          <br />
          <br />
          A SYNTH magazine with a cover story on Lilith Tyrell, exploring how
          traumatic memories are used to control replicants.
          <br />
          <br />
          Skinner lit a cigarette, and the city outside exhaled steam.
          <br />
          <br />
          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },
  ];

  useEffect(() => {
    document.body.style.backgroundImage = `url(${require("../../../../src/assets/blade-runner/background-blade-runner-01.webp")})`;
    document.body.style.backgroundColor = "#000000";
    document.body.style.backgroundWidth = "100vw";
    document.body.backgroundHeight = "100vh";
    document.body.style.backgroundSize = "cover";
  }, []);

  return (
    <Container>
      <Row>
        <Col>
          <div
            style={{
              backgroundColor: "transparent",
              fontFamily: "Orbitron",
            }}
          >
            <div style={pageHeader}>
              <main role="main" className="inner cover text-center">
                <a name="pageTop" href="#pageTop">
                  <img
                    src={bladeRunnerLogo}
                    style={{
                      maxWidth: "400px",
                      backgroundColor: "white",
                      borderRadius: "10px",
                    }}
                    alt="Blade Runner campaign"
                  />
                </a>
              </main>

              <h1 className="cover-heading">SAFEHOUSE</h1>
              <small>Blade Runner Session 04</small>

              {/* <p className="lead leadExtra">
                <BRSubNav />
              </p> */}
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card style={cardStyle}>
            {/* <img src={sectionDivider} alt="section divider" /> */}
            <Card.Body>
              <Card.Title
                id="cardTitle-blade-runner"
                className="cardTitle-blade-runner  "
              >
                <span
                  style={{
                    color: "white",
                    textAlign: "center",
                  }}
                >
                  Marion passes baseline, Skinner has a run-in with Styles, and
                  our detectives confront The Aurelian on Animoid Row to
                  discover the location of replicant underground safehouse.
                </span>
                <br />
                <font
                  style={{
                    color: "#C21E56",
                    textAlign: "center",
                    fontStyle: "italic",
                  }}
                >
                  WARNING: SPOILERS for Electric Dreams case file.{" "}
                </font>
                <br />
                <small>
                  ⇐ Session 03:{" "}
                  <a href="./blade-runner-session-03">Memory Lab</a> -- Session
                  05: <a href="./blade-runner-session-05">Mindkill</a> ⇒{" "}
                </small>
              </Card.Title>
              <div>
                <ContentContainer data={section1Data} />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default BRSession04;
